var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-pessoa wrapper-md"},[_c('pessoa-abas',{attrs:{"pessoa":_vm.arrematante.pessoa}}),_c('pessoa-planejamento',{attrs:{"pessoa":_vm.arrematante.pessoa}}),_c('pessoa-historico',{attrs:{"pessoa":_vm.arrematante.pessoa}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }